import React, { FC } from 'react';
import {
  Controller,
  UseControllerProps,
  useFormContext,
  // UseFormReturn,
} from 'react-hook-form';
import { ValueLabelOption } from './ValueLabelOption';
import {
  AutoCompleteValueLabel,
  AutoCompleteValueLabelProps,
} from './AutoCompleteValueLabel';

export const findSelectedValueLabelOptions = (
  options: ValueLabelOption[] = [],
  selectedValues: string[] = []
): ValueLabelOption[] => {
  // options is an array of options for an autoselect element
  // need to return references to the autoselect options for the selected values
  const selectedOptions: ValueLabelOption[] = [];
  selectedValues.forEach(value => {
    const foundOption = options.find(option => option.value === value);
    if (!!foundOption) {
      selectedOptions.push(foundOption);
    }
  });
  return selectedOptions;
};

export const findSingleSelectedValueLabelOption = (
  options: ValueLabelOption[],
  selectedValue: string
): ValueLabelOption => {
  // options is an array of options for an autoselect element
  // selectedValue is a string value representing the single option that should be selected
  // need to return references to the autoselect option corresponding to the selected values
  return options?.find(item => item.value === selectedValue);
};

export interface RHFAutoCompleteProps extends AutoCompleteValueLabelProps {
  rules?: UseControllerProps['rules'];
  RHFAutoCompleteOnChangeHandler?: Function;
  removeValuesMissingInOptions?: boolean;
  invalidValuesValue?: ValueLabelOption | ValueLabelOption[];
}
const invalidValues = {
  value: 'NONE_OR_BARE',
  label: 'NONE OR BARE',
};

export const getInvalidValuesValue = () => {
  return {
    ...invalidValues,
  };
};

export const RHFAutoComplete: FC<RHFAutoCompleteProps> = (
  props: RHFAutoCompleteProps
) => {
  const methods = useFormContext();
  const {
    options,
    removeValuesMissingInOptions,
    invalidValuesValue,
    name,
  } = props;

  return (
    <Controller
      name={props.name}
      control={methods.control}
      rules={props.rules}
      render={({
        field: { onChange, value, ref: fieldRef, onBlur },
        fieldState: { error },
      }) => {
        if (removeValuesMissingInOptions) {
          if (Array.isArray(value)) {
            const updateValues = value.filter(v =>
              options.find(oV => oV.value === v.value)
            );
            if (value.length > 0 && updateValues.length === 0) {
              methods.setValue(name, invalidValuesValue);
            } else if (value.length !== updateValues.length) {
              methods.setValue(name, updateValues);
            }
          } else if (value) {
            // value is not null
            if (!options.find(o => o.value === value.value)) {
              if (value.value !== invalidValues.value) {
                methods.setValue(name, invalidValuesValue);
              }
            }
          }
        }
        return (
          <AutoCompleteValueLabel
            value={value}
            InputRef={fieldRef}
            onBlurHandler={() => {
              onBlur();
            }}
            onChangeHandler={value => {
              onChange(value);
              if (props.RHFAutoCompleteOnChangeHandler) {
                props.RHFAutoCompleteOnChangeHandler(value);
              }
            }}
            error={error}
            {...props}
          />
        );
      }}
    />
  );
};
